import PoolDetail from '@/page/pools/PoolDetail';
import PortfolioMain from '@/page/portfolio/PortFolioMain';
import PoolMain from '@/page/pools/PoolMain';
import PortfolioDetail from '@/page/portfolio/PortfolioDetail';

export default function RouterList() {
  return [
    {
      name: 'startPage',
      url: '/',
      element: <PoolMain />,
      private: false,
    },

    {
      name: 'portfolio',
      url: '/portfolio',
      element: <PortfolioMain />,
      private: false,
    },

    {
      name: 'poolDetail',
      url: '/poolDetail',
      element: <PoolDetail />,
      private: false,
    },

    {
      name: 'pools',
      url: '/pools',
      element: <PoolMain />,
      private: false,
    },
    {
      name: 'portfolioMain',
      url: '/portfolioMain',
      element: <PortfolioMain />,
      private: false,
    },
    {
      name: 'portfolioDetail',
      url: '/portfolioDetail',
      element: <PortfolioDetail />,
      private: false,
    },
  ];
  // return LinkList;
}
